import * as React from 'react'

import { observer } from 'mobx-react'

import { Button } from '~/client/src/shared/components/shadcn-ui/button'
import Localization from '~/client/src/shared/localization/LocalizationManager'

// localization: translated

interface IProps {
  isDraftBtnEnabled: boolean
  isSubmitBtnEnabled: boolean

  onDraftClick: () => void
  onSubmitClick: () => void
}

export default observer(WorkflowSubmissionButtons)

function WorkflowSubmissionButtons({
  isDraftBtnEnabled,
  isSubmitBtnEnabled,
  onDraftClick,
  onSubmitClick,
}: IProps): JSX.Element {
  return (
    <div
      data-app-chrome="surface"
      className="tw:flex tw:shrink-0 tw:items-center tw:gap-4 tw:border-0 tw:border-t tw:border-solid tw:border-border tw:bg-background tw:px-5 tw:pt-5 tw:pb-safe-5"
    >
      <Button
        variant="outline"
        className="tw:flex-1"
        disabled={!isDraftBtnEnabled}
        onClick={onDraftClick}
      >
        {Localization.translator.saveAsDraft}
      </Button>
      <Button
        className="tw:flex-1"
        disabled={!isSubmitBtnEnabled}
        onClick={onSubmitClick}
      >
        {Localization.translator.submit_verb}
      </Button>
    </div>
  )
}
